function EventInventoryCtrl($scope, $state, $stateParams, $q, sdkVenueService, eventService, sdkUtils, dateUtilsService, alertService, managementUserService, ERROR_MESSAGES, organizationService, mapperService, venueService, urlService) { //eslint-disable-line
  const vm = this;

  vm.loading = true;
  vm.venueId = $stateParams.venueId;
  vm.addEventInstance = {
    onSaving() {
      vm.saving = true;
    },
    onSaved(updatedEvent) {
      vm.saving = false;

      vm.eventForm = updatedEvent;
    }
  }; //this will get filled in by the Add-Event directive and allow us to call into it
  vm.saveEvent = function ($event) {
    if ($event) $event.preventDefault();

    vm.addEventInstance.saveEvent();
  };

  const dataPromises = [
    $scope.venuePromise,
    $scope.eventPromise
  ];

  $q.all(dataPromises)
    .then(results => {
      vm.venue = results[0];
      vm.event = results[1];

      const mappedEvent = mapperService.mapEventToUI(results[1]);

      vm.eventForm = mappedEvent;

      vm.loading = false;
    });
}

EventInventoryCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$q',
  'jsSdk.venue',
  'jsSdk.event',
  'jsSdk.utils',
  'dateUtilsService',
  'alertService',
  'jsSdk.managementUser',
  'ERROR_MESSAGES',
  'organizationService',
  'mapperService',
  'venueService',
  'urlService'
];

export default EventInventoryCtrl;



// WEBPACK FOOTER //
// ./src/components/eventInventory/eventInventoryCtrl.js